import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Card, Form, Input } from 'antd';
import React from 'react';

interface LoginFormProps {
  onLogin: (username: string, password: string) => Promise<void>;
  onSwitchToRegister: () => void;
  showSwitchButton?: boolean;
}

const LoginForm: React.FC<LoginFormProps> = ({ onLogin, onSwitchToRegister, showSwitchButton = true }) => {
  const [form] = Form.useForm();

  const handleSubmit = async (values: { username: string; password: string }) => {
    await onLogin(values.username, values.password);
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: showSwitchButton ? '60vh' : 'auto' }}>
      <Card title={showSwitchButton ? "登录" : undefined} style={{ width: 400, border: showSwitchButton ? undefined : 'none', boxShadow: showSwitchButton ? undefined : 'none' }}>
        <Form form={form} onFinish={handleSubmit} layout="vertical">
          <Form.Item
            name="username"
            rules={[{ required: true, message: '请输入用户名' }]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder="用户名"
              size="large"
            />
          </Form.Item>
          
          <Form.Item
            name="password"
            rules={[{ required: true, message: '请输入密码' }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder="密码"
              size="large"
            />
          </Form.Item>
          
          <Form.Item>
            <Button type="primary" htmlType="submit" size="large" block>
              登录
            </Button>
          </Form.Item>

          {showSwitchButton && (
            <Form.Item>
              <Button
                type="link"
                onClick={onSwitchToRegister}
                block
              >
                没有账号？立即注册
              </Button>
            </Form.Item>
          )}
        </Form>
      </Card>
    </div>
  );
};

export default LoginForm;